import Rule from "../../../common/rule";
import FootballState from "../../state/football-state";

export default class GameStart extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return fragment.associatedState === FootballState.GameStart;
    }
    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { offenseTeam } = fragment;
        gameContext.setPossessionForTeamId(offenseTeam.id);

        ruleContext.setResetField(true);
    }
}
